const backToTopButton = document.querySelector('[data-back-to-top]');
const showOffset = 200;
let lastScrollTop = window.pageYOffset;

backToTopButton.onclick = () => {
    document.documentElement.scroll({
        top: 0,
        behavior: 'smooth',
    });
};

window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > showOffset && currentScroll > lastScrollTop) {
        backToTopButton.style.visibility = 'visible';
        backToTopButton.style.opacity = '1';
    } else if (currentScroll > showOffset && currentScroll < lastScrollTop) {
        backToTopButton.style.visibility = 'hidden';
        backToTopButton.style.opacity = '0';
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
});
